import type { Environment } from "../../types";
import { CHAIN_IDS } from "../../lib/constants";

export { WALLET_API, CHAIN_IDS } from "../../lib/constants";

/**
 * CROSSD 토큰 컨트랙트 주소 (mainnet / testnet). 주소 자체가 네트워크별로
 * 유일하므로 env 분기 없이 두 주소로만 CROSSD를 판별한다. 소문자로 비교한다.
 */
export const CROSSD_TOKEN_ADDRESSES = new Set(
  [
    "0xff42c13d927a6b9265236619161accb227b6d452", // mainnet
    "0x9364ea6790f6e0ecfaa5164085f2a7de34ec55fb", // testnet
  ].map((address) => address.toLowerCase()),
);

/** CROSSD 컨트랙트 주소로 판별한다 (mainnet/testnet). 대소문자 무시. */
export function isCrossdTokenAddress(address: string): boolean {
  return CROSSD_TOKEN_ADDRESSES.has(address.toLowerCase());
}

export const FORGE_API: Record<Environment, string> = {
  dev: "https://stg-bonding-curve-api.crosstoken.io/api",
  stage: "https://stg-bonding-curve-api.crosstoken.io/api",
  production: "https://bonding-curve-api.crosstoken.io/api",
};

export const CHAIN_BADGE_ICONS: Record<"cross" | "bsc", string> = {
  cross: "https://contents.crosstoken.io/wallet/token/images/CROSS.svg",
  bsc: "https://contents.crosstoken.io/wallet/token/images/BSC.svg",
};

export function getChainBadgeUrl(
  env: Environment,
  chainId: number,
): string | undefined {
  const chains = CHAIN_IDS[env];
  if (chainId === chains.cross) return CHAIN_BADGE_ICONS.cross;
  if (chainId === chains.bsc) return CHAIN_BADGE_ICONS.bsc;
  return undefined;
}

/** 지갑 주소로부터 자동 생성되는 프로필 이미지(portrait) 서비스 엔드포인트. */
export const PORTRAIT_API: Record<Environment, string> = {
  dev: "https://dev-portrait.crosstoken.io",
  stage: "https://dev-portrait.crosstoken.io",
  production: "https://portrait.crosstoken.io",
};

export interface PortraitUrlOptions {
  /** 출력 이미지 크기(px). 기본 120. */
  size?: number;
  /** 배경색 hex (# 없이). 미지정 시 투명. */
  bg?: string;
  /** 파일 포맷. 기본 "png". */
  format?: "png" | "svg";
}

/**
 * EVM 지갑 주소로부터 자동 생성되는 프로필 이미지(portrait) URL을 반환.
 * @example
 *   getPortraitUrl("stage", "0xd8dA...", { size: 120, bg: "1A1A2E" })
 */
export function getPortraitUrl(
  env: Environment,
  address: string,
  opts: PortraitUrlOptions = {},
): string | undefined {
  if (!address || !address.startsWith("0x")) return undefined;
  const { size = 120, bg, format = "png" } = opts;
  const base = PORTRAIT_API[env];
  const bgParam = bg ? `&bg=${bg}` : "";
  return `${base}/portrait/evm/${address}.${format}?size=${size}${bgParam}`;
}
